import { announcementServiceApi } from "../../app/announcementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  AnnouncementDetailsResponseType,
  GetAnnouncementParamsType,
  GetAnnouncementResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const announcementApi = announcementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncementList: builder.query<
      GetAnnouncementResponseType,
      GetQueryArgsType<GetAnnouncementParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAnnouncementList,
        ...queryArgs,
      }),
      providesTags: ["GetAnnouncementList"],
    }),
    getAnnouncementDetails: builder.query<
      AnnouncementDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getAnnouncementDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetAnnouncementDetails", id }],
    }),
    createAnnouncement: builder.mutation({
      query: (data) => ({
        url: API_URL.createAnnouncement,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetAnnouncementList"],
    }),
    updateAnnouncement: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ id, body }) => ({
        url: `${API_URL.updateAnnouncement}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAnnouncementList",
            {
              type: "GetAnnouncementDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetAnnouncementListQuery,
  useGetAnnouncementDetailsQuery,
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
} = announcementApi;
